/* The desktop header renders its navigation in place. Native details handles opening. */
(() => {
  if (window.prCompactNavigationInstalled) return;
  window.prCompactNavigationInstalled = true;
  const menus = '[data-pr-compact-nav] details[open]';

  const shop = '[data-pr-compact-nav] .prm-desktop-nav__shop';
  let leaveTimer;
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse') return;
    const menu = event.target.closest?.(shop);
    if (!menu?.open || menu.contains(event.relatedTarget)) return;
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => {
      if (menu.open && !menu.matches(':hover') && !menu.querySelector(':focus-visible')) menu.open = false;
    }, 350);
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'mouse' && event.target.closest?.(shop)) clearTimeout(leaveTimer);
  });

  function closeOutside(target) {
    document.querySelectorAll(menus).forEach(menu => {
      if (!menu.contains(target)) menu.open = false;
    });
  }
  function fit() {
    const panel = document.querySelector(menus + ' > .pr-compact-nav__panel');
    if (panel) panel.style.setProperty('--pr-panel-height', Math.max(90, window.innerHeight - panel.getBoundingClientRect().top - 12) + 'px');
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(menus)) { closeOutside(event.target); fit(); }
  }, true);
  document.addEventListener('click', event => closeOutside(event.target));
  document.addEventListener('focusin', event => closeOutside(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector(menus);
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  window.matchMedia('(min-width: 1025px)').addEventListener('change', () => closeOutside(null));
  window.addEventListener('resize', fit);
  window.addEventListener('scroll', fit, { passive: true });
})();
